import {renderCatalogPage} from "./render-catalog-page";
import {initPage} from "./init-page";

window.addEventListener(`load`, () => {
  initPage();
  renderCatalogPage(catalogList);
});
